import script from "./OTrilhaDeNavegacao.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTrilhaDeNavegacao.vue?vue&type=script&lang=ts&setup=true"

import "./OTrilhaDeNavegacao.vue?vue&type=style&index=0&id=37d63855&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d63855"]])

export default __exports__